import React, {Component} from 'react';
import {Link, withRouter} from 'react-router-dom';
import {AccessGateMessage} from './DetailsAccessGate';
import BackButton from './BackButton';
import Pagination from './Pagination';
import Autocomplete from './Autocomplete';


class PropertySearch extends Component {

  constructor() {
    super();
    this.state = JSON.parse(window.localStorage.getItem('propertySearch_State')) || {
      searchValue: '',
      errorMessage: null,
      isLoading: false,
      matchingAddresses: [],
      page: 0,
      hasNext: false,
      hasPrevious: false
    };
  }

  setState(state) {
    window.localStorage.setItem('propertySearch_State', JSON.stringify(state));
    super.setState(state);
  }

  handleOnChange = value => {
    this.setState({
      searchValue: value,
      errorMessage: null,
      isLoading: false,
      matchingAddresses: [],
      page: 0,
      hasNext: false,
      hasPrevious: false}
    );
  };

  fetchAddressSuggestions = query => this.props.propertyApi.suggestAddress(query);

  handleSuggestionSelect = address => {
    const canViewDetails = this.props.authenticated && this.props.subscriptionStatus && this.props.subscriptionStatus.status === "active";
    if (canViewDetails) {
      this.props.history.push(`/transactions?propertyId=${address.propertyId}`);
    } else {
      this.setState({
        searchValue: address.propertyAddressFull,
        errorMessage: null,
        isLoading: false,
        matchingAddresses: [address],
        page: 0,
        hasNext: false,
        hasPrevious: false
      });
    }
  };

  async makeApiCall(searchInput, page = 0) {
    const response = await this.props.propertyApi.searchByAddress(searchInput, page);
    if (!response.ok) {
      this.setState({
        searchValue: searchInput,
        errorMessage: `Search by address failed: ${response.status} ${response.statusText}`,
        isLoading: false,
        matchingAddresses: [],
        page: 0,
        hasNext: false,
        hasPrevious: false
      })
    } else {
      const jsonData = await response.json();
      if(jsonData.content.length === 0) {
        this.setState({
          searchValue: searchInput,
          errorMessage: `No results found. Please revise your input`,
          isLoading: false,
          matchingAddresses: [],
          page: 0,
          hasNext: false,
          hasPrevious: false
        })
      }
      this.setState({
        searchValue: searchInput,
        errorMessage: null,
        isLoading: false,
        matchingAddresses: jsonData.content,
        page: jsonData.page,
        hasNext: jsonData.hasNext,
        hasPrevious: jsonData.hasPrevious
      });
    }
  };

  handleSearch = () => {
    this.setState({
      searchValue: this.state.searchValue,
      errorMessage: null,
      isLoading: true,
      matchingAddresses: [],
      page: 0,
      hasNext: false,
      hasPrevious: false}
    );
    this.makeApiCall(this.state.searchValue, 0);
  };

  handlePageChange = page => {
    this.setState({isLoading: true});
    this.makeApiCall(this.state.searchValue, page);
  };

  handleClear = () => {
    this.setState({
      searchValue: '',
      errorMessage: null,
      isLoading: false,
      matchingAddresses: [],
      page: 0,
      hasNext: false,
      hasPrevious: false}
    );
  };

  handleKeyDown = event => {
    if (event.key === 'Enter') {
      this.handleSearch();
    }
  };

  render() {
    const {errorMessage, isLoading, searchValue, matchingAddresses, page, hasNext, hasPrevious} = this.state;
    const canViewDetails = this.props.authenticated && this.props.subscriptionStatus && this.props.subscriptionStatus.status === "active";

    return (
      <div className="app">
        {this.props.navbar}
        <div className="page-container">
          <BackButton/>
          <span className="page-eyebrow">Property search</span>
          <h2 className="page-title">Search by address</h2>
          <p className="page-subtitle">
            To get better search results, use abbreviations like Ln for Lane, St for Street,
            Blvd for Boulevard, etc. You can also search with just the street name if it's
            unique enough &mdash; e.g. <i>Sunset Dr</i>.
          </p>

          {errorMessage &&
            <div className="alert callout callout-warning">{errorMessage}</div>
          }

          <Autocomplete
            name="text"
            placeholder="e.g. 123 Sunset Dr"
            value={searchValue}
            onChange={this.handleOnChange}
            onKeyDown={this.handleKeyDown}
            fetchSuggestions={this.fetchAddressSuggestions}
            getSuggestionKey={address => address.propertyId}
            renderSuggestion={address => `${address.propertyAddressFull}, ${address.propertyAddressCity}`}
            onSelect={this.handleSuggestionSelect}
          />

          <div className="search-actions">
            <button className="btn-brand btn-brand-primary" onClick={this.handleSearch}>Search</button>
            <button className="btn-brand btn-brand-ghost" onClick={this.handleClear}>Clear</button>
          </div>

          {isLoading &&
            <div className="loading-row"><span className="spinner"/> Searching...</div>
          }

          {matchingAddresses && matchingAddresses.length > 0 &&
            <AccessGateMessage authenticated={this.props.authenticated} subscriptionStatus={this.props.subscriptionStatus}/>
          }

          {matchingAddresses && matchingAddresses.length > 0 &&
            <div className="result-list">
              {matchingAddresses.map((address, index) => (
                canViewDetails ?
                  <Link key={index} className="result-row is-link" to={`/transactions?propertyId=${address.propertyId}`}>
                    <span className="result-row-title">{address.propertyAddressFull}, {address.propertyAddressCity}</span>
                    <svg className="result-row-arrow" width="18" height="18" viewBox="0 0 24 24" fill="none">
                      <path d="M9 6l6 6-6 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </Link>
                  :
                  <div key={index} className="result-row">
                    <span className="result-row-title">{address.propertyAddressFull}, {address.propertyAddressCity}</span>
                  </div>
              ))}
            </div>
          }

          {matchingAddresses && matchingAddresses.length > 0 &&
            <Pagination page={page} hasNext={hasNext} hasPrevious={hasPrevious} onPageChange={this.handlePageChange}/>
          }
        </div>
      </div>
    );
  }
}

export default withRouter(PropertySearch);
